document.addEventListener("DOMContentLoaded", () => {

  const widgets = document.querySelectorAll("[data-installments-widget]");

  if (!widgets.length) return;

  const formatMoney = (cents) => {

    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL"
    }).format(cents / 100);

  };

  widgets.forEach((widget) => {

    const variantsEl = widget.querySelector(
      "[data-installments-variants]"
    );

    if (!variantsEl) return;

    let variants = [];

    try {

      variants = JSON.parse(
        variantsEl.textContent.trim()
      );

    } catch (e) {

      console.error("Erro variantes:", e);

      return;

    }

    const modal = widget.querySelector(
      "[data-installments-modal]"
    );

    if (!modal) return;

    // MOVE MODAL PRO BODY
    document.body.appendChild(modal);

    const trigger = widget.querySelector(
      "[data-installments-trigger]"
    );

    const summaryAmount = widget.querySelector(
      "[data-installments-summary-amount]"
    );

    // AGORA BUSCA DENTRO DO MODAL
    const installmentAmounts = modal.querySelectorAll(
      "[data-installment-amount]"
    );

    const totalLines = modal.querySelectorAll(
      "[data-installments-total-line]"
    );

    const closeButtons = modal.querySelectorAll(
      "[data-installments-close]"
    );

    const getVariantId = () => {

      const input = document.querySelector(
        'input[name="id"]'
      );

      return Number(input?.value);

    };

    const getCurrentVariant = () => {

      const id = getVariantId();

      return (
        variants.find(v => v.id === id)
        || variants[0]
      );

    };

    const renderInstallments = () => {

      const variant = getCurrentVariant();

      if (!variant) return;

      const price = Number(variant.price);

      // RESUMO
      summaryAmount.textContent = formatMoney(
        Math.round(price / 6)
      );

      // LISTA
      installmentAmounts.forEach((el) => {

        const qty = Number(
          el.dataset.installmentAmount
        );

        const installmentValue = Math.round(
          price / qty
        );

        el.textContent = formatMoney(
          installmentValue
        );

      });

      // TOTAL
      totalLines.forEach((el) => {

        el.textContent = formatMoney(price);

      });

    };

    const openModal = () => {

      modal.hidden = false;

      document.documentElement.style.overflow = "hidden";

    };

    const closeModal = () => {

      modal.hidden = true;

      document.documentElement.style.overflow = "";

    };

    // OPEN
    trigger?.addEventListener(
      "click",
      openModal
    );

    // CLOSE
    closeButtons.forEach((btn) => {

      btn.addEventListener(
        "click",
        closeModal
      );

    });

    // ESC
    document.addEventListener(
      "keydown",
      (e) => {

        if (
          e.key === "Escape"
          && !modal.hidden
        ) {

          closeModal();

        }

      }
    );

    // FECHAR CLICANDO NO FUNDO
    modal.addEventListener(
      "click",
      (e) => {

        if (
          e.target.classList.contains(
            "installments-modal__overlay"
          )
        ) {

          closeModal();

        }

      }
    );

    // UPDATE VARIANT
    document.addEventListener(
      "change",
      () => {

        setTimeout(
          renderInstallments,
          100
        );

      }
    );

    renderInstallments();

  });

});